/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_Error_AbsenceInputs */



/**
* | output |
* | --- |
* | "The room temperature is too close to the absence temperature" |
*
* @param {Calibration_Temperature_Error_AbsenceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_error_absence = /** @type {((inputs?: Calibration_Temperature_Error_AbsenceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Error_AbsenceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The room temperature is too close to the absence temperature")
	return /** @type {LocalizedString} */ ("La température de la pièce est trop proche de la température d'absence")
});